/* eslint-disable react/function-component-definition */
import { IoetIcon } from "@icons";
import { Button as MuiButton } from "@mui/material";
import React from "react";
import { Icon } from "src/v2/components/atoms/Icon";
import { Typography } from "../Typography";
import { IButtonProps } from "./types";

const Button: React.FC<IButtonProps> = ({
  variant = "contained",
  color = "primary",
  size = "medium",
  iconPosition,
  icon,
  disabled = false,
  disableElevation = false,
  text,
  onClick,
  iconStyle,
  sx,
  type,
  bold = true,
  rounded,
}) => {
  const iconType = () => {
    if (typeof icon === "string") {
      return <Icon icon={(icon as IoetIcon) || "default"} style={iconStyle} />;
    }
    return icon;
  };
  return (
    <MuiButton
      variant={variant ?? "contained"}
      color={color ?? "primary"}
      size={size ?? "medium"}
      startIcon={iconPosition === "left" ? iconType() : null}
      endIcon={iconPosition === "right" ? iconType() : null}
      disabled={disabled ?? false}
      disableElevation={disableElevation ?? false}
      onClick={onClick}
      type={type}
      sx={[
        { textTransform: "none", ...sx, borderRadius: rounded ? "2rem" : "" },
      ]}
    >
      <Typography variant='button' sx={{ textTransform: "none" }} bold={bold}>
        {text}
      </Typography>
    </MuiButton>
  );
};

export default Button;
